import React from 'react';
import { MapControl, ControlPosition, useMap } from '@vis.gl/react-google-maps';
import classNames from 'classnames/bind';

import { MAX_ZOOM_LEVEL, MIN_ZOOM_LEVEL } from './Map';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface MapControllerProps {
  onRetry?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const MapController: React.FC<MapControllerProps> = ({ onRetry }) => {
  const map = useMap();

  const handleControllZoom = (isZoomIn: boolean) => {
    const currentZoomLevel = map?.getZoom();

    if (!map || !currentZoomLevel) {
      return;
    }

    const caclulatedZoomLevel = isZoomIn
      ? currentZoomLevel + 1
      : currentZoomLevel - 1;

    map.setZoom(
      Math.max(Math.min(caclulatedZoomLevel, MAX_ZOOM_LEVEL), MIN_ZOOM_LEVEL),
    );
  };

  const handleRefreshZoom = () => {
    if (!map) {
      return;
    }
    map.setZoom(MIN_ZOOM_LEVEL);
  };

  return (
    <MapControl position={ControlPosition.RIGHT_TOP}>
      <div className={cx('MapController')}>
        <button
          type="button"
          className={cx('refresh')}
          aria-label="새로고침"
          data-event-nlog="click"
          data-event-area-code="rcm.maprefresh"
          onClick={handleRefreshZoom}
        />
        <div className={cx('zoom')}>
          <button
            type="button"
            className={cx('zoomin')}
            aria-label="확대"
            aria-disabled={false}
            data-event-nlog="click"
            data-event-area-code="rcm.mapzoom"
            onClick={() => handleControllZoom(true)}
          />
          <button
            type="button"
            className={cx('zoomout')}
            aria-label="축소"
            aria-disabled={false}
            data-event-nlog="click"
            data-event-area-code="rcm.mapzoomout"
            onClick={() => handleControllZoom(false)}
          />
        </div>
        {onRetry && (
          <button
            type="button"
            className={cx('retry')}
            aria-label="현 지도에서 검색"
            data-event-nlog="click"
            data-event-area-code="rcm.mapsearch"
            onClick={onRetry}
          >
            <span className={cx('tooltip')} role="tooltip">
              현 지도에서 검색
            </span>
          </button>
        )}
      </div>
    </MapControl>
  );
};

export default MapController;
